export class ResetPasswordRequestVO{
    private oldPassword: string;
    private newPassword: string;
    private confirmPassword: string;

    public setOldPassword(oldPassword: string): void{
        this.oldPassword = oldPassword;
    }

    public setNewPassword(newPassword: string): void{
        this.newPassword = newPassword;
    }
    
    public setConfirmPassword(confirmPassword: string): void{
        this.confirmPassword = confirmPassword;
    }

    public getOldPassword(): string{
        return this.oldPassword;
    }
    
    public getNewPassword(): string{
        return this.newPassword;
    }
    
    public getConfirmPassword(): string{
        return this.confirmPassword;
    }
}


// WEBPACK FOOTER //
// ./src/app/profile/resetpassword.model.ts